import styled from '@emotion/styled';

export const LinkText = styled.a`
  color: ${({ theme }) => theme.color.blue.default};
  cursor: pointer;
  font-weight: 600;
`;
export const AddressText = styled.span`
  color: ${(props) => props.theme.color.blue.default};
`;

export const Wrapper = styled.div`
  position: relative;
`;

export const BlurContent = styled.div<{ blurred: boolean }>`
  ${(props) =>
    props.blurred &&
    `
  filter: blur(4px);
  background-color: rgba(255, 255, 255, 0.3);
  `}
`;

export const BlurOverlay = styled.div`
  z-index: 1;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;
